import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {ApiService} from "../../../../service/ApiService";
import {Loader} from "../../../../components/admin/Loader";
import {SizeForm} from "../../../../components/admin/equipment/SizeForm";
import {sizeResultType} from "../../../../types/Api/SizeResultType";
import {size} from "../../../../models/size";
import {sizeHydrator} from "../../../../models/hydrator/sizeHydrator";
import {BoxTitle} from "../../../../components/admin/BoxTitle";

export const Edit = () => {
  const uuid: undefined|string = useParams().uuid;

  const [size, setSize] = useState(undefined as undefined | size);
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    if (uuid) {
      const result = ApiService.get(`/size/${uuid}`) as Promise<sizeResultType>;

      setLoading(true);

      result
        .then((r) => {
          setSize(sizeHydrator.hydrate(r));
        })
        .catch(() => {
          alert("Une erreur c'est produite.")
        })
        .finally(() => {
          setLoading(false);
        });
    }

  }, [uuid]);

  return (
    <>
      {loading && (
        <Loader/>
      )}

      {!loading && (size || !uuid) && (
        <>
          <BoxTitle title={uuid ? 'Modifier une taille' : 'Ajouter une taille'}/>
          <SizeForm size={size} />
        </>
      )}
    </>
  );
}
